import { FileToDownload } from '~src/utils/download';
import { appLog } from '~src/utils/log';
import { saveFromLink } from '~src/utils/downloader/shared/saveFromLink';
import { DownloadingState, useStore } from '~src/store';

/** Download already picked `FileToDownload`
 *
 * To be used for large files individual download
 */

export const downloadSelectedVersion = async (file: FileToDownload) => {
  appLog('downloadSelectedVersion ->', file);
  useStore.getState().changeDownloadingState(DownloadingState.DOWNLOADING);

  if (file.location) {
    // trigger download
    saveFromLink(file.location, file.title);
  }

  useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
  setTimeout(() => {
    useStore.getState().changeDownloadingActive(false);
  }, 3_000);
};
